import $ from "jquery";
import axios from "axios";

(function () {
    const changeSubmit = {
        init: function () {
            $('body')
                .on('change', 'form .js-change-submit', function (e) {
                    $(this).closest('form')
                        .trigger('submit');
                })
                .on('click', '.js-click-submit', function (e) {
                    e.preventDefault();
                    const $this = $(this),
                        form = $this.data('form') ? $($this.data('form')) : $this.closest('form');
                    console.log(form);
                    form.trigger('submit');
                })
                .on('click', '#order-form label[for^="orderBy-"]', function () {
                    $(this).nextAll('.order-arrow').trigger('click');
                });

            this.fileInputs();
        },

        fileInputs: function () {
            $('[type=file]').on('change', function () {
                const file = this.files[0];
                $('.file-attach')
                    .after($('<div class="attached-file">' + file.name + '<span>&times;</span></div>'))
                    .hide();
            });

            $(".license-item__image a").fancybox({
                baseClass: 'license-modal'
            });

            $('body').on('click', '.attached-file span', function () {
                const parent = $(this).parent();
                parent.prev()
                    .show()
                    .find('input[type="file"]')
                    .val(null);
                parent.remove();
            });
        }
    }.init();

    const modalForms = {
        init: function () {
            $('body')
                .on('submit-success', 'form.success-modal-close', function (e) {
                    $(this).closest('.modal').modal('hide');
                });
        }
    }.init();

    const ajaxForms = {
        init: function () {
            $('body').on('submit', 'form.js-submit', function (e) {
                e.preventDefault();

                var form = $(this);

                if (form.hasClass('form--loading')) {
                    new Noty({
                        text: 'Please, wait until the end of request'
                    }).show();
                    return false;
                }

                let method = form.attr('method') || 'GET',
                    action = form.attr('action'),
                    request;

                form.addClass('form--loading');
                form.find('.invalid-feedback').remove();
                form.find('.is-invalid').removeClass('is-invalid');

                if (method === 'POST') {
                    request = axios.post(action, form.serialize());
                } else {
                    request = axios.get(action, form.serialize());
                }

                request.then(function (response) {
                    console.log(response);
                    form.removeClass('form--loading');
                    form.trigger('submit-success', response.data);
                    if (typeof response.data.message !== 'undefined') {
                        new Noty({
                            text: response.data.message,
                            type: 'success'
                        }).on('afterClose', () => {
                            if (typeof response.data.redirect !== 'undefined') {
                                window.location.href = response.data.redirect;
                            }
                        }).show();
                    }
                }).catch(function (error) {
                    form.trigger('submit-fail');
                    form.removeClass('form--loading');
                    if (typeof error.response.data.message !== 'undefined') {
                        new Noty({
                            text: error.response.data.message,
                            type: 'error'
                        }).show();

                        if (typeof error.response.data.errors !== 'undefined') {
                            $.each(error.response.data.errors, function (key, messages) {
                                form.find('[name="' + key + '"]')
                                    .addClass('is-invalid')
                                    .after('<div class="invalid-feedback">' + messages[0] + '</div>');
                            });
                        }
                    } else {
                        new Noty({
                            text: error.message,
                            type: 'error'
                        }).show();
                    }
                });
            });
        }
    }.init();
})();


// WEBPACK FOOTER //
// ./resources/assets/js/utils/forms.js